import styled, { StyledProps } from 'styled-components/macro';

export type CellSwitchStylesProps = StyledProps<{
  disabled: any;
}>;

export const CellSwitch = styled.div<CellSwitchStylesProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${(props) => props.disabled ? 'none' : 'auto'};
  opacity: ${(props) => props.disabled ? '.8' : '1'};
`;